import axios from "axios";
import { getTokenData } from "../../../../shared/utils/utils";
import { ApiError } from "../../../../shared/utils/errors/ApiError";

/**
 * Atualiza configurações do WhatsApp (API ou Web)
 */
export async function updateWhatsApp({
  channel,
  channel_id,
  category = "Geral",
  auto_reply,
}) {
  try {
    const { token, client_id } = await getTokenData();

    // 🔒 Validações básicas
    if (!token) {
      throw new ApiError({
        error: "auth_error",
        message: "Token de autenticação não encontrado",
      });
    }

    if (!client_id) {
      throw new ApiError({
        error: "auth_error",
        message: "ID do cliente não encontrado",
      });
    }

    if (!channel) {
      throw new ApiError({
        error: "validation_error",
        message: "Canal não informado",
      });
    }

    if (!channel_id) {
      throw new ApiError({
        error: "validation_error",
        message: "ID do canal não informado",
      });
    }

    if (!auto_reply || typeof auto_reply !== "object") {
      throw new ApiError({
        error: "validation_error",
        message: "Configuração de auto resposta inválida",
      });
    }

    // 🔹 Normaliza o canal para a URL
    const normalizedChannel = channel
      .toLowerCase()
      .replace(/_/g, "");

    // 🚀 Chamada da API
    const response = await axios.patch(
      `${process.env.REACT_APP_BACKEND_AWS_URL}/channels/${normalizedChannel}/config`,
      {
        channel_id,
        category,
        auto_reply,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
          Client_ID: client_id,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar configuração do WhatsApp:", error);

    if (axios.isAxiosError(error)) {
      const apiError = error.response?.data;
      if (apiError?.error && apiError?.message) {
        throw new ApiError(apiError);
      }
    }

    if (error instanceof ApiError) {
      throw error;
    }

    throw new ApiError({
      error: "unknown_error",
      message: "Erro ao atualizar configuração do WhatsApp",
    });
  }
}
